import settings from '@/constants/constants';
import { useEffect } from 'react';

import datadog from '@/providers/datadog';
import googleTagManager from '@/providers/googleTagManager';
import useFeatureFlags from './useFeatureFlags';

export default function useTrackingProviders({ ready }: { ready: boolean }) {
  const { flags } = useFeatureFlags();

  useEffect(() => {
    if (ready) {
      datadog(flags, settings);
      googleTagManager(settings);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [settings, ready]);
  return {};
}
